export default function userApi(axios, serverUrl) {
  return {
    getPublicEntities: async ({ username, ids = [] }) => {
      const { data: { entities } } = await axios({
        method: 'get',
        url: `${serverUrl}/eb/user/entities`,
        params: {
          username,
          ids,
        },
      });
      return entities;
    },
    getPublicProfile: async ({ username, userId }) => {
      const { data: { user } } = await axios({
        method: 'get',
        url: `${serverUrl}/eb/user/profile`,
        params: {
          username,
          userId
        },
      });
      return user;
    }, 
  };
};
